const backgroundAudioStatus = {
    ENDED: 'ended',
    INIT: 'init',
    PAUSED: 'paused',
    PLAYING: 'playing',
    REWOUND: 'rewound',
};

export default backgroundAudioStatus;
